module.exports = __webpack_public_path__ + "static/media/Google.cceb53b9.ico";